// extracted by mini-css-extract-plugin
module.exports = {"weekBorder":"TimetableTimeline_weekBorder_ad2j2"};